<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: security-groups.component.html
 * Generated by: ianday
 * Date .......: 7/17/25
--------------------------------------->
<div class="security-groups-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%">
            <TR>
                <TD class="table-title-cell">
                    <i class="fa fa-medkit fa-fw table-icon-header"
                       style="width: 2em"></i>{{ formTitle }}
                </TD>

                <TD align="left" style="min-width: 400px;">
                    <input text id="txtFilter" #txtFilter
                           class="qs_filter-field" [disabled]="this.isEditing"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon>close</mat-icon>
                    </button>
                </TD>
                <TD class="qs-label-cell" style="width: 60px; text-align: center;">Status:</TD>
                <TD style="width: 150px">
                    <mat-select [disabled]="isEditing"
                            disableOptionCentering
                            [(value)]="selectedStatusFilter" #cbStatus floatLabel="never"
                            class="dw-mat-select"
                            style="font-size: 10pt;width: 120px;"
                            panelClass="local-drop-down-panel"
                            (selectionChange)="txtFilter.value=''; onChangeStatusFilterValue()">
                        <mat-option value='All'>All</mat-option>
                        <mat-option value='Active'>Active</mat-option>
                        <mat-option value='InActive'>InActive</mat-option>
                    </mat-select>
                </TD>
                <TD class="table-pagination-cell" align="right">{{ pagination }} Record(s) ...</TD>
            </TR>
        </table>
    </div>

    <div>
        <!-------------------------->
        <!-- Right hand drawer    -->
        <!-- Open state           -->
        <!-------------------------->

        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div #tb1 [ngClass]="contentClassName" class="table-container mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                    <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on
                  the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Id
                        </th>
                        <td mat-cell style="width:8% !important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.id }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Description
                        </th>
                        <td mat-cell style="width:50% !important;"
                            *matCellDef="let element">{{ element.name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="activeStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            style="background-color: white; z-index:99999">Status
                        </th>
                        <td mat-cell *matCellDef="let element" >
                            <mat-select *ngIf="selectedRecord?.id == element.id"
                                        disableOptionCentering
                                        [(value)]="element.activeStatus" #cbStatus floatLabel="never"
                                        class="dw-mat-select"
                                        panelClass="local-drop-down-panel"
                                        style="width:95px!important;"
                                        (selectionChange)="onStatusChange()"
                                        [disabled]="selectedRecord?.id !== element.id">
                                <mat-option value="Active">Active</mat-option>
                                <mat-option value="InActive">InActive</mat-option>
                            </mat-select>
                            <span *ngIf="selectedRecord?.id !== element.id"
                                  style="padding-left: 3px;">{{ element.activeStatus }}</span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)"
                        (dblclick)="launchSecurityDialog()">
                    </tr>
                </table>
            </div>
            <!-------------------------------------->
            <!-- Control Strip                    -->
            <!-------------------------------------->
            <div class="mat-elevation-z2 control-strip">
                <button *ngIf="visibleAdd" mat-button [disabled]="this.isEditing"
                        matTooltipPosition="above"
                        class="command-button" matTooltip="Add a new record"
                        (click)="addModifyRecord(true)" mat-button>
                    <mat-icon>add_circle_outline</mat-icon>
                    Add New
                </button>
                <button *ngIf="visibleModify" mat-button class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0|| this.isEditing)"
                        matTooltip="Update a selected record" (click)="addModifyRecord(false)"
                        mat-button>
                    <mat-icon>edit</mat-icon>
                    Edit
                </button>
                <button *ngIf="visibleDelete" mat-button class="command-button"
                        matTooltipPosition="above"
                        style="margin-top: 5px;" [disabled]="(Idx < 0 || this.isEditing)"
                        matTooltip="Remove a selected record" (click)="removeRecord()"
                        mat-button>
                    <mat-icon>remove_circle_outline</mat-icon>
                    Remove
                </button>
                <button *ngIf="visibleSecurity" mat-button class="command-button"
                        style="margin-top: 5px;"
                        [disabled]="(Idx < 0 || this.isEditing)"
                        matTooltip="Configure Security for the selected record"
                        (click)="launchSecurityDialog()" mat-button>
                    <mat-icon>key</mat-icon>
                    Security
                </button>
            </div>
            <!------------------------------->
            <!--  Detail panel             -->
            <!------------------------------->
            <div id="security-groups-details-panel" class="security-groups-detail-container mat-elevation-z2"
                 style="margin-bottom: 2px;">
                <mat-tab-group animationDuration="0ms" (selectedTabChange)="doTabChange($event)"
                               [(selectedIndex)]=selectedTabIndex>
                    <mat-tab label="Details" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <div class="dwform" style="padding-right: 15px;">

                                <div class="dwform-cell-nopadding" style="min-width: 500px;">

                                    <div class="dwform-row-double-gap"></div>
                                    <div class="dwform-row">
                                        <label class="label-field">ID:</label> <span
                                            class="form-required"> </span>
                                        <input class="input-field-short" style="width:80px" disabled="true"
                                               [(ngModel)]="id"
                                               type="text">
                                    </div>

                                    <div class="dwform-row-gap"></div>

                                    <div class="dwform-row">
                                        <label class="label-field">Group Name:</label>
                                        <span class="form-required">*</span>
                                        <input class="input-field-longest"
                                               style="text-transform: capitalize"
                                               [disabled]="!isEditing"
                                               [(ngModel)]="name"
                                               placeholder="<Name>"
                                               type="text">

                                        <div class="dwform-row-gap"></div>

                                        <div class="dwform-row">
                                            <label class="label-field">Status:</label> <span
                                                class="form-required">*</span>

                                            <mat-select [disabled]="!isEditing" [(ngModel)]="activeStatus"
                                                        placeholder="- Please Select -"
                                                        disableOptionCentering
                                                        floatLabel="never"
                                                        panelClass="local-drop-down-panel"
                                                        class="dw-mat-select"
                                                        style="width: 230px;font-size: 10pt;"
                                                        [style.backgroundColor]="disabledFlag?'whitesmoke':'white'">
                                                <mat-option value="Active">Active</mat-option>
                                                <mat-option value="InActive">InActive</mat-option>
                                            </mat-select>
                                        </div>
                                    </div>
                                </div>
                                <!----------------------->
                                <!-- ERROR LINE --------->
                                <!----------------------->
                                <div class="error-line" [hidden]='!strErr.length'
                                     style="text-align:left">{{ strErr }}
                                </div>
                                <!----------------------->
                                <!-- SAVE STRIP        -->
                                <!----------------------->
                                <div class="save-close-strip" style="bottom: 3px;">

                                    <button mat-button class="command-button" *ngIf="this.isEditing"
                                            (click)="submitRecord()" matTooltip="Submit the selected record"
                                            mat-button>
                                        <mat-icon>check_circle_outline</mat-icon>
                                        Submit
                                    </button>
                                    <button mat-button class="command-button" *ngIf="this.isEditing"
                                            (click)="cancelSubmitRecord()" matTooltip="Cancel edit" mat-button>
                                        <mat-icon>highlight_off</mat-icon>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="History" [disabled]="isEditing">
                        <div class="sub-tab-container-class detail-tab-additional">
                            <transaction-history #history></transaction-history>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>

<p-dialog header="Group Security for '{{ selectedRecord?.name}}'"
          [appendTo]="'body'"
          [(visible)]="displaySecurityDialog"
          [modal]="true"
          [style]="{position: 'absolute',  minWidth: '805px', minHeight: '780px', width: '805px', height:'780px'}"
          [minY]="75" [closable]="true"
          [resizable]="false" >
    <app-security #dlgSecurity
                  [CalledFrom]="'groupMgmt'"
                  [ParentId]=selectedRecord?.id
                  (submitButton)="doSecuritySubmit()"
                  (cancelButton)="displaySecurityDialog=false">
    </app-security>
</p-dialog>
